var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"VModal":""}},_vm._l((_vm.modals),function(v,k){return _c(v.name,{key:k,tag:"component",on:{"ready":function (comp){_vm.readyComponent(comp, v)},"callback":v.callback}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }